if (!customElements.get("fabric-swatches")) {  customElements.define(
    "fabric-swatches",
    class FabricSwatches extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.swatchLimit = parseInt(this.dataset.swatchLimit) || 3;
        this.pcDefault = parseInt(this.dataset.pcDefault) || 16;
        this.mobileDefault = parseInt(this.dataset.mobileDefault) || 8;
        this.pcLoadMore = parseInt(this.dataset.pcLoadMore) || 16;
        this.mobileLoadMore = parseInt(this.dataset.mobileLoadMore) || 8;

        this.currentCategory = "curtains";
        this.currentViewMode = "fabric";

        /* 购物车状态 */
        this.cartSwatchVariantIds = new Set();
        this.cartSwatchLineKeys = {};
        this.pendingAdds = new Set();
        this.pendingRemoves = new Set();
        this.requestQueue = [];
        this.isProcessingQueue = false;
        this.pendingAddTasks = [];
        this.addBatchTimer = null;
        this.cartSyncTimer = null;
        this.cartSyncInFlight = false;
        this.cartSyncPromise = null;
        this.nextCartSyncDelay = null;
        this.addBatchDelay = 1000;
        this.cartSyncDelay = 1200;
        this.cartRetryDelay = 1200;

        /* 顶部筛选状态 */
        this.filters = {
          material: "",
          series: "",
          color: "",
        };
        this.filterSelects = {};
        this.filterOptionMaps = {
          material: new Map(),
          series: new Map(),
          color: new Map(),
        };
        this.filterTagsEl = null;
        this.clearFiltersBtn = null;

        /* 底部已选浮层状态 */
        this.selectedTray = null;
        this.selectedTrayItems = null;
        this.selectedTrayDismissed = false;
        this.lastSelectedCount = 0;
        this.cartSwatchItems = [];
        this.optimisticSwatchItems = {};

        /* 预加载弹层大图缓存（避免重复请求） */
        this.prefetchedModalPreviewUrls = new Set();
      }

      /* ========== 分类 Tab 切换 ========== */
      syncCategoryViewLabel() {
        const curtainLabel = this.querySelector('.fs-view-btn[data-view="curtain"]');
        if (!curtainLabel) return;
        curtainLabel.textContent = this.currentCategory === "roller-shades" ? "Shade" : "Curtain";
      }

      initCategoryTabs() {
        const activeTab = this.querySelector(".fs-category-tab.is-active");
        if (activeTab && activeTab.dataset.category) {
          this.currentCategory = activeTab.dataset.category;
        }
        this.syncCategoryViewLabel();

        const tabs = this.querySelectorAll(".fs-category-tab");
        tabs.forEach((tab) => {
          tab.addEventListener("click", () => {
            const category = tab.dataset.category;
            if (category === this.currentCategory) return;

            this.currentCategory = category;

            tabs.forEach((t) => t.classList.remove("is-active"));
            tab.classList.add("is-active");

            const groups = this.querySelectorAll(".fs-category-group");
            groups.forEach((g) => {
              g.classList.toggle(
                "is-active",
                g.dataset.categoryGroup === category,
              );
            });

            this.syncCategoryViewLabel();
            this.syncFilterOptionsForActiveCategory();
            this.applyFiltersAndVisibility();
          });
        });
      }

      /* ========== Curtain / Fabric 全局图模式切换 ========== */
      initViewToggle() {
        const labels = this.querySelectorAll(".fs-view-btn[data-view]");
        const toggleEl = this.querySelector(".fs-view-toggle");
        const switchBtn = this.querySelector('.fs-view-switch[data-action="toggle-view"]');
        const syncToggleState = () => {
          const activeMode = this.currentViewMode === "curtain" ? "curtain" : "fabric";
          if (toggleEl) {
            toggleEl.dataset.active = activeMode;
          }
          labels.forEach((label) => {
            label.classList.toggle("is-active", label.dataset.view === activeMode);
          });
        };

        const applyMode = (mode) => {
          if (mode === this.currentViewMode) {
            syncToggleState();
            return;
          }

          this.currentViewMode = mode;
          syncToggleState();

          this.classList.remove(
            "fs-view-mode--curtain",
            "fs-view-mode--fabric",
          );
          this.classList.add(`fs-view-mode--${mode}`);

          this.querySelectorAll(".swatch-card").forEach((card) => {
            card.classList.remove("is-local-curtain", "is-local-fabric");
          });

          this.updateAllThumbToggles();
        };

        syncToggleState();

        if (switchBtn) {
          switchBtn.addEventListener("click", () => {
            const nextMode = this.currentViewMode === "fabric" ? "curtain" : "fabric";
            applyMode(nextMode);
          });
        }
      }

      /* ========== 单卡右下角缩略图切换 ========== */
      initCardThumbToggles() {
        this.addEventListener("click", (e) => {
          const toggleBtn = e.target.closest(
            '[data-action="toggle-card-view"]',
          );
          if (!toggleBtn) return;

          e.stopPropagation();
          const card = toggleBtn.closest(".swatch-card");
          if (!card) return;

          const thumbImg = toggleBtn.querySelector("img");
          if (!thumbImg) return;

          const currentCardMode = this.getCardViewMode(card);
          const newLocalMode =
            currentCardMode === "fabric" ? "curtain" : "fabric";

          card.classList.remove("is-local-curtain", "is-local-fabric");

          if (newLocalMode !== this.currentViewMode) {
            card.classList.add(`is-local-${newLocalMode}`);
          }

          this.updateThumbToggle(card);
        });
      }

      getCardViewMode(card) {
        if (card.classList.contains("is-local-curtain")) return "curtain";
        if (card.classList.contains("is-local-fabric")) return "fabric";
        return this.currentViewMode;
      }

      updateThumbToggle(card) {
        const thumbBtn = card.querySelector('[data-action="toggle-card-view"]');
        if (!thumbBtn) return;
        const thumbImg = thumbBtn.querySelector("img");
        if (!thumbImg) return;

        const currentMode = this.getCardViewMode(card);
        if (currentMode === "fabric") {
          thumbImg.src = thumbImg.dataset.curtainThumb;
        } else {
          thumbImg.src = thumbImg.dataset.fabricThumb;
        }
      }

      updateAllThumbToggles() {
        this.querySelectorAll(".swatch-card").forEach((card) => {
          this.updateThumbToggle(card);
        });
      }

      /* ========== 顶部筛选（Material / Series / Color） ========== */
      normalizeFilterLabel(value) {
        return String(value || "").trim();
      }

      normalizeFilterKey(value) {
        return this.normalizeFilterLabel(value).toLowerCase();
      }

      getActiveCategoryGroup() {
        return this.querySelector(".fs-category-group.is-active");
      }

      getCardColorValue(cardWrapper) {
        const wrapperColor = this.normalizeFilterLabel(cardWrapper.dataset.swatchColor);
        if (wrapperColor) return wrapperColor;
        const card = cardWrapper.querySelector(".swatch-card");
        return this.normalizeFilterLabel(card && card.dataset ? card.dataset.swatchColor : "");
      }

      collectFilterOptionsForActiveCategory() {
        const maps = {
          material: new Map(),
          series: new Map(),
          color: new Map(),
        };
        const activeGroup = this.getActiveCategoryGroup();
        if (!activeGroup) return maps;

        activeGroup.querySelectorAll(".fs-collection-block").forEach((block) => {
          const materialLabel = this.normalizeFilterLabel(block.dataset.material);
          const materialKey = this.normalizeFilterKey(materialLabel);
          if (materialKey && !maps.material.has(materialKey)) {
            maps.material.set(materialKey, materialLabel);
          }

          const seriesLabel = this.normalizeFilterLabel(block.dataset.series);
          const seriesKey = this.normalizeFilterKey(seriesLabel);
          if (seriesKey && !maps.series.has(seriesKey)) {
            maps.series.set(seriesKey, seriesLabel);
          }

          block.querySelectorAll(".swatch-card-wrapper").forEach((cardWrapper) => {
            const colorLabel = this.getCardColorValue(cardWrapper);
            const colorKey = this.normalizeFilterKey(colorLabel);
            if (colorKey && !maps.color.has(colorKey)) {
              maps.color.set(colorKey, colorLabel);
            }
          });
        });

        return maps;
      }

      renderFilterSelect(key) {
        const select = this.filterSelects[key];
        if (!select) return;

        const defaultLabel =
          select.dataset.defaultLabel ||
          (select.options[0] ? select.options[0].textContent : `All ${key}`);
        const optionMap = this.filterOptionMaps[key] || new Map();
        const options = Array.from(optionMap.entries()).sort((a, b) =>
          a[1].localeCompare(b[1], undefined, { sensitivity: "base" }),
        );
        const currentValue = this.filters[key];

        select.innerHTML = "";
        const defaultOption = document.createElement("option");
        defaultOption.value = "";
        defaultOption.textContent = defaultLabel;
        select.appendChild(defaultOption);

        options.forEach(([value, label]) => {
          const option = document.createElement("option");
          option.value = value;
          option.textContent = label;
          select.appendChild(option);
        });

        if (currentValue && optionMap.has(currentValue)) {
          select.value = currentValue;
        } else {
          this.filters[key] = "";
          select.value = "";
        }
      }

      syncFilterOptionsForActiveCategory() {
        this.filterOptionMaps = this.collectFilterOptionsForActiveCategory();
        this.renderFilterSelect("material");
        this.renderFilterSelect("series");
        this.renderFilterSelect("color");
        this.syncFilterUI();
      }

      syncFilterUI() {
        const configs = [
          { key: "material", label: "Material" },
          { key: "series", label: "Series" },
          { key: "color", label: "Color" },
        ];

        if (this.filterTagsEl) {
          this.filterTagsEl.innerHTML = "";
          configs.forEach(({ key, label }) => {
            const value = this.filters[key];
            if (!value) return;

            const displayLabel =
              this.filterOptionMaps[key] && this.filterOptionMaps[key].has(value)
                ? this.filterOptionMaps[key].get(value)
                : value;
            const tag = document.createElement("button");
            tag.type = "button";
            tag.className = "fs-filter-tag";
            tag.dataset.action = "remove-filter-tag";
            tag.dataset.filterKey = key;
            tag.textContent = `${label}: ${displayLabel} ×`;
            this.filterTagsEl.appendChild(tag);
          });
          this.filterTagsEl.classList.toggle(
            "is-empty",
            this.filterTagsEl.childElementCount === 0,
          );
        }

        const hasActiveFilter =
          !!this.filters.material || !!this.filters.series || !!this.filters.color;
        if (this.clearFiltersBtn) {
          this.clearFiltersBtn.classList.toggle("is-hidden", !hasActiveFilter);
          this.clearFiltersBtn.disabled = !hasActiveFilter;
        }
      }

      clearAllFilters() {
        this.filters.material = "";
        this.filters.series = "";
        this.filters.color = "";

        Object.values(this.filterSelects).forEach((select) => {
          if (select) select.value = "";
        });

        this.applyFiltersAndVisibility();
      }

      matchesBlockFilter(block) {
        const blockMaterial = this.normalizeFilterKey(block.dataset.material);
        const blockSeries = this.normalizeFilterKey(block.dataset.series);

        if (this.filters.material && blockMaterial !== this.filters.material) {
          return false;
        }
        if (this.filters.series && blockSeries !== this.filters.series) {
          return false;
        }

        return true;
      }

      matchesColorFilter(cardWrapper) {
        if (!this.filters.color) return true;
        const colorValue = this.normalizeFilterKey(this.getCardColorValue(cardWrapper));
        if (!colorValue) return true;
        return colorValue === this.filters.color;
      }

      applyFiltersAndVisibility() {
        const activeGroup = this.getActiveCategoryGroup();
        if (!activeGroup) return;

        const blocks = activeGroup.querySelectorAll(".fs-collection-block");
        let totalMatchedCards = 0;

        blocks.forEach((block) => {
          const blockMatched = this.matchesBlockFilter(block);
          const cards = block.querySelectorAll(".swatch-card-wrapper");
          let matchedCountInBlock = 0;

          cards.forEach((cardWrapper) => {
            const matched = blockMatched && this.matchesColorFilter(cardWrapper);
            cardWrapper.classList.toggle("is-filter-hidden", !matched);
            if (matched) {
              matchedCountInBlock++;
            }
          });

          block.classList.toggle("is-filter-hidden", matchedCountInBlock === 0);

          if (matchedCountInBlock > 0) {
            this.applyBlockVisibility(block, this.getDefaultCount());
            totalMatchedCards += matchedCountInBlock;
          } else {
            const loadMoreBtn = block.querySelector(".fs-load-more-btn");
            if (loadMoreBtn) loadMoreBtn.classList.add("is-hidden");
            block.dataset.visibleCount = 0;
          }
        });

        const emptyState = activeGroup.querySelector("[data-empty-state]");
        if (emptyState) {
          emptyState.hidden = totalMatchedCards > 0;
        }

        this.syncFilterUI();
      }

      initFilters() {
        this.filterSelects = {
          material: this.querySelector('[data-filter-key="material"]'),
          series: this.querySelector('[data-filter-key="series"]'),
          color: this.querySelector('[data-filter-key="color"]'),
        };
        this.filterTagsEl = this.querySelector("[data-filter-tags]");
        this.clearFiltersBtn = this.querySelector('[data-action="clear-filters"]');

        Object.entries(this.filterSelects).forEach(([key, select]) => {
          if (!select) return;
          select.addEventListener("change", () => {
            this.filters[key] = this.normalizeFilterKey(select.value);
            this.applyFiltersAndVisibility();
          });
        });

        if (this.clearFiltersBtn) {
          this.clearFiltersBtn.addEventListener("click", () => {
            this.clearAllFilters();
          });
        }

        if (this.filterTagsEl) {
          this.filterTagsEl.addEventListener("click", (e) => {
            const tag = e.target.closest('[data-action="remove-filter-tag"]');
            if (!tag) return;

            const key = tag.dataset.filterKey;
            if (!key || !this.filters[key]) return;

            this.filters[key] = "";
            if (this.filterSelects[key]) {
              this.filterSelects[key].value = "";
            }
            this.applyFiltersAndVisibility();
          });
        }

        this.syncFilterOptionsForActiveCategory();
      }

      /* ========== Load More ========== */
      get isMobile() {
        return window.innerWidth < 750;
      }

      getDefaultCount() {
        return this.isMobile ? this.mobileDefault : this.pcDefault;
      }

      getLoadMoreCount() {
        return this.isMobile ? this.mobileLoadMore : this.pcLoadMore;
      }

      applyInitialVisibility() {
        this.applyFiltersAndVisibility();
      }

      applyBlockVisibility(block, visibleCount) {
        const cards = Array.from(block.querySelectorAll(".swatch-card-wrapper"));
        const visibleCards = cards.filter(
          (card) => !card.classList.contains("is-filter-hidden"),
        );
        const loadMoreBtn = block.querySelector(".fs-load-more-btn");
        let hasHidden = false;

        cards.forEach((card) => {
          card.classList.add("is-hidden");
        });

        visibleCards.forEach((card, index) => {
          if (index < visibleCount) {
            card.classList.remove("is-hidden");
          } else {
            card.classList.add("is-hidden");
            hasHidden = true;
          }
        });

        if (loadMoreBtn) {
          loadMoreBtn.classList.toggle("is-hidden", !hasHidden);
        }

        block.dataset.visibleCount = Math.min(visibleCount, visibleCards.length);
      }

      initLoadMore() {
        this.addEventListener("click", (e) => {
          const loadMoreBtn = e.target.closest('[data-action="load-more"]');
          if (!loadMoreBtn) return;

          const block = loadMoreBtn.closest(".fs-collection-block");
          if (!block) return;

          const currentVisible =
            parseInt(block.dataset.visibleCount) || this.getDefaultCount();
          const newVisible = currentVisible + this.getLoadMoreCount();

          this.applyBlockVisibility(block, newVisible);
        });
      }

      /* ==========================================================
         第二步：购物车同步 + Add/Remove + 串行队列
         ========================================================== */

      /* 初始化：读取购物车，同步按钮状态 */
      async initCartSync() {
        try {
          const cartData = window.CartApiProxy
            ? await window.CartApiProxy.getCart(3000)
            : await fetch(window.routes.cart_url + ".js", { credentials: "same-origin", cache: "no-store" }).then(function (r) { return r.json(); });
          this.syncFromCart(cartData);
        } catch (err) {
          console.warn("[FabricSwatches] Failed to fetch cart:", err);
        } finally {
          this.setAllButtonsLoading(false);
        }
      }

      /* 全局锁定/解锁所有按钮为 loading 状态 */
      setAllButtonsLoading(loading) {
        this.querySelectorAll(".swatch-card__add-btn").forEach((btn) => {
          if (btn.classList.contains("is-sold-out")) return;
          btn.classList.toggle("is-loading", loading);
          btn.disabled = loading;
        });
      }

      /* 从 cart 数据同步页面状态 */
      syncFromCart(cartData) {
        this.cartSwatchVariantIds.clear();
        this.cartSwatchLineKeys = {};
        this.cartSwatchItems = [];
        this.optimisticSwatchItems = {};

        if (cartData && cartData.items) {
          cartData.items.forEach((item) => {
            const props = item.properties || {};
            if (props._is_swatch === "1") {
              const vid = String(item.variant_id);
              this.cartSwatchVariantIds.add(vid);
              this.cartSwatchLineKeys[vid] = item.key;
              this.cartSwatchItems.push({
                variantId: vid,
                title: item.product_title || item.title || "",
                image:
                  (item.featured_image && item.featured_image.url) ||
                  item.image ||
                  "",
              });
            }
          });
        }

        this.updateAllButtonStates();
        this.updateSelectedCounter();
      }

      /* 获取有效样品总数（真实 + pending add - pending remove） */
      getEffectiveSwatchCount() {
        let count = this.cartSwatchVariantIds.size;
        this.pendingAdds.forEach((vid) => {
          if (!this.cartSwatchVariantIds.has(vid)) count++;
        });
        this.pendingRemoves.forEach((vid) => {
          if (this.cartSwatchVariantIds.has(vid)) count--;
        });
        return Math.max(0, count);
      }

      /* 是否达到上限 */
      isAtLimit() {
        return this.getEffectiveSwatchCount() >= this.swatchLimit;
      }

      /* 判断某 variant 是否已在购物车或 pending add 中 */
      isVariantInCart(variantId) {
        const vid = String(variantId);
        if (this.pendingRemoves.has(vid)) return false;
        return this.cartSwatchVariantIds.has(vid) || this.pendingAdds.has(vid);
      }

      clearLocalSwatchState(variantId) {
        const vid = String(variantId);
        this.cartSwatchVariantIds.delete(vid);
        delete this.cartSwatchLineKeys[vid];
        delete this.optimisticSwatchItems[vid];
        this.cartSwatchItems = this.cartSwatchItems.filter(
          (item) => String(item.variantId) !== vid,
        );
      }

      initSelectedTray() {
        this.selectedTray = this.querySelector("[data-selected-tray]");
        this.selectedTrayItems = this.querySelector("[data-selected-items]");
        if (!this.selectedTray) return;

        this.selectedTray.addEventListener("click", (e) => {
          const closeBtn = e.target.closest('[data-action="dismiss-selected-tray"]');
          if (closeBtn) {
            this.selectedTrayDismissed = true;
            this.updateSelectedTrayVisibility(this.getEffectiveSwatchCount());
            return;
          }

          const cartLink = e.target.closest(".fs-selected-tray__cart-link");
          if (!cartLink) return;
          e.preventDefault();
          const fallbackUrl = cartLink.getAttribute("href");
          this.flushPendingAddTasks();
          this.waitForQueueIdle().then(() => {
            this.openCartDrawer(fallbackUrl);
          });
        });
      }

      openCartDrawer(fallbackUrl) {
        const cartOpener = document.querySelector(
          'modal-opener[aria-controls="Cart-Drawer"]',
        );
        const cartDrawer = document.getElementById("Cart-Drawer");

        if (
          cartOpener &&
          cartOpener.modal &&
          typeof cartOpener.modal.show === "function"
        ) {
          cartOpener.modal.show(cartOpener);
          return;
        }

        if (cartDrawer && typeof cartDrawer.show === "function") {
          cartDrawer.show(cartOpener || null);
          return;
        }

        if (cartOpener) {
          cartOpener.dispatchEvent(
            new MouseEvent("click", { bubbles: true, cancelable: true }),
          );
          return;
        }

        window.location.href = fallbackUrl || "/cart";
      }

      getSwatchItemFromSource(variantId, sourceDataEl) {
        const item = {
          variantId: String(variantId),
          title: sourceDataEl && sourceDataEl.dataset ? sourceDataEl.dataset.productTitle || "" : "",
          image: "",
        };

        if (!sourceDataEl) return item;

        let imageEl = null;
        if (sourceDataEl.classList && sourceDataEl.classList.contains("swatch-card")) {
          imageEl = sourceDataEl.querySelector(".swatch-card__img--fabric");
        } else {
          const modal = sourceDataEl.closest("swatch-detail-modal");
          if (modal) {
            imageEl = modal.querySelector(".swatch-modal__img--fabric");
          }
        }

        if (imageEl) {
          item.image = imageEl.currentSrc || imageEl.src || "";
        }

        return item;
      }

      getEffectiveSwatchItems() {
        const itemsMap = new Map();

        this.cartSwatchItems.forEach((item) => {
          itemsMap.set(item.variantId, item);
        });

        Object.entries(this.optimisticSwatchItems).forEach(([vid, item]) => {
          if (!itemsMap.has(vid)) {
            itemsMap.set(vid, item);
          }
        });

        this.pendingRemoves.forEach((vid) => {
          itemsMap.delete(String(vid));
        });

        return Array.from(itemsMap.values());
      }

      renderSelectedTrayItems() {
        if (!this.selectedTrayItems) return;

        const items = this.getEffectiveSwatchItems();
        this.selectedTrayItems.innerHTML = "";

        items.forEach((item) => {
          const thumb = document.createElement("div");
          thumb.className = "fs-selected-tray__thumb";
          thumb.title = item.title || "Swatch";

          if (item.image) {
            const img = document.createElement("img");
            img.src = item.image;
            img.alt = item.title || "Swatch";
            img.loading = "lazy";
            img.width = 96;
            img.height = 96;
            thumb.appendChild(img);
          } else {
            const placeholder = document.createElement("span");
            placeholder.className = "fs-selected-tray__thumb-placeholder";
            placeholder.textContent = "Swatch";
            thumb.appendChild(placeholder);
          }

          this.selectedTrayItems.appendChild(thumb);
        });
      }

      updateSelectedTrayVisibility(count) {
        if (!this.selectedTray) return;
        const shouldShow = count > 0 && !this.selectedTrayDismissed;
        this.selectedTray.hidden = !shouldShow;
        this.selectedTray.classList.toggle("is-hidden", !shouldShow);
      }

      /* 更新已选计数器与底部浮层 */
      updateSelectedCounter() {
        const count = this.getEffectiveSwatchCount();

        this.querySelectorAll("[data-selected-count]").forEach((countEl) => {
          countEl.textContent = count;
        });

        if (count !== this.lastSelectedCount) {
          this.selectedTrayDismissed = false;
          this.lastSelectedCount = count;
        }

        this.renderSelectedTrayItems();
        this.updateSelectedTrayVisibility(count);
      }

      /* 更新所有按钮状态 */
      updateAllButtonStates() {
        const atLimit = this.isAtLimit();

        this.querySelectorAll(".swatch-card__add-btn").forEach((btn) => {
          if (btn.classList.contains("is-sold-out")) return;

          const vid = String(btn.dataset.variantId);
          const inCart = this.isVariantInCart(vid);
          const isPending =
            this.pendingAdds.has(vid) || this.pendingRemoves.has(vid);

          btn.classList.toggle("is-added", inCart);
          btn.classList.toggle("is-loading", isPending);
          btn.classList.toggle("is-disabled", !inCart && atLimit);

          if (inCart) {
            btn.textContent = "Remove";
          } else {
            btn.textContent = "Add Swatch";
          }

          btn.disabled = isPending || (!inCart && atLimit);
        });

        /* 同步所有弹层内的按钮 */
        document.querySelectorAll("swatch-detail-modal:not([hidden])").forEach((modal) => {
          if (modal._syncButtons) modal._syncButtons();
        });
      }

      /* 单个按钮状态更新 */
      updateButtonState(variantId) {
        const vid = String(variantId);
        const btns = this.querySelectorAll(
          `.swatch-card__add-btn[data-variant-id="${vid}"]`,
        );

        const inCart = this.isVariantInCart(vid);
        const isPending =
          this.pendingAdds.has(vid) || this.pendingRemoves.has(vid);
        const atLimit = this.isAtLimit();

        btns.forEach((btn) => {
          if (btn.classList.contains("is-sold-out")) return;

          btn.classList.toggle("is-added", inCart);
          btn.classList.toggle("is-loading", isPending);
          btn.classList.toggle("is-disabled", !inCart && atLimit);

          if (inCart) {
            btn.textContent = "Remove";
          } else {
            btn.textContent = "Add Swatch";
          }

          btn.disabled = isPending || (!inCart && atLimit);
        });

        /* 同步当前打开弹层内若显示的是同一 variant */
        document.querySelectorAll("swatch-detail-modal:not([hidden])").forEach((modal) => {
          const modalBtn = modal.querySelector(".swatch-modal__add-btn");
          if (modalBtn && String(modalBtn.dataset.variantId) === vid) {
            if (modal._syncButtons) modal._syncButtons();
          }
        });
      }

      /* ========== Add / Remove 事件绑定 ========== */
      initSwatchActions() {
        this.addEventListener("click", (e) => {
          const btn = e.target.closest('[data-action="add-swatch"]');
          if (!btn || btn.disabled) return;

          const vid = String(btn.dataset.variantId);
          const sourceDataEl = btn.closest(".swatch-card") || btn;

          if (this.isVariantInCart(vid)) {
            this.removeSwatch(vid);
          } else {
            this.addSwatch(vid, sourceDataEl);
          }
        });
      }

      /* 加购样品 */
      addSwatch(variantId, sourceDataEl) {
        const vid = String(variantId);

        if (this.isAtLimit()) return;
        if (this.isVariantInCart(vid)) return;

        this.optimisticSwatchItems[vid] = this.getSwatchItemFromSource(
          vid,
          sourceDataEl,
        );

        this.pendingAdds.add(vid);
        this.updateButtonState(vid);
        this.updateAllButtonStates();
        this.updateSelectedCounter();

        const properties = {
          _is_swatch: "1",
          _swatch_collection_handle: sourceDataEl.dataset.collectionHandle || "",
          _swatch_collection_title: sourceDataEl.dataset.collectionTitle || "",
          _swatch_product_id: sourceDataEl.dataset.productId || "",
          _swatch_product_title: sourceDataEl.dataset.productTitle || "",
          _swatch_view_mode: this.currentViewMode,
          _swatch_limit: String(this.swatchLimit),
        };

        this.enqueueAddRequest({
          variantId: vid,
          properties,
        });

        if (this.isAtLimit()) {
          this.flushPendingAddTasks();
        }
      }

      /* 移除样品 */
      removeSwatch(variantId) {
        const vid = String(variantId);

        if (!this.isVariantInCart(vid)) return;

        if (!this.cartSwatchVariantIds.has(vid) && this.cancelPendingAdd(vid)) {
          delete this.optimisticSwatchItems[vid];
          this.pendingAdds.delete(vid);
          this.updateButtonState(vid);
          this.updateAllButtonStates();
          this.updateSelectedCounter();
          return;
        }

        this.pendingRemoves.add(vid);
        this.updateButtonState(vid);
        this.updateAllButtonStates();
        this.updateSelectedCounter();

        this.enqueueRequest({
          type: "remove",
          variantId: vid,
        });
      }

      /* ========== 串行请求队列 ========== */
      enqueueAddRequest(task) {
        this.pendingAddTasks.push(task);
        if (this.addBatchTimer) {
          window.clearTimeout(this.addBatchTimer);
        }
        this.addBatchTimer = window.setTimeout(() => {
          this.flushPendingAddTasks();
        }, this.addBatchDelay);
      }

      flushPendingAddTasks() {
        if (this.addBatchTimer) {
          window.clearTimeout(this.addBatchTimer);
          this.addBatchTimer = null;
        }
        if (this.pendingAddTasks.length === 0) return;
        const tasks = this.pendingAddTasks.splice(0);
        this.enqueueRequest({
          type: "add-batch",
          tasks,
        });
      }

      cancelPendingAdd(variantId) {
        const vid = String(variantId);
        const pendingIndex = this.pendingAddTasks.findIndex(
          (task) => String(task.variantId) === vid,
        );
        if (pendingIndex > -1) {
          this.pendingAddTasks.splice(pendingIndex, 1);
          if (this.pendingAddTasks.length === 0 && this.addBatchTimer) {
            window.clearTimeout(this.addBatchTimer);
            this.addBatchTimer = null;
          }
          return true;
        }

        let cancelled = false;
        this.requestQueue.forEach((task) => {
          if (task.type !== "add-batch" || !Array.isArray(task.tasks)) return;
          const before = task.tasks.length;
          task.tasks = task.tasks.filter(
            (addTask) => String(addTask.variantId) !== vid,
          );
          if (task.tasks.length !== before) cancelled = true;
        });
        this.requestQueue = this.requestQueue.filter(
          (task) => task.type !== "add-batch" || task.tasks.length > 0,
        );

        return cancelled;
      }

      enqueueRequest(task) {
        this.requestQueue.push(task);
        if (!this.isProcessingQueue) {
          this.processQueue();
        }
      }

      async processQueue() {
        if (this.requestQueue.length === 0) {
          this.isProcessingQueue = false;
          if (this._needsCartSync) {
            this._needsCartSync = false;
            const syncDelay =
              typeof this.nextCartSyncDelay === "number"
                ? this.nextCartSyncDelay
                : this.cartSyncDelay;
            this.nextCartSyncDelay = null;
            this.scheduleCartSync(syncDelay);
          }
          return;
        }

        this.isProcessingQueue = true;
        const task = this.requestQueue.shift();

        let cartData = null;
        let taskSucceeded = false;
        try {
          if (task.type === "add-batch") {
            cartData = await this.executeAddBatch(task.tasks);
          } else if (task.type === "remove") {
            cartData = await this.executeRemove(task);
          }
          taskSucceeded = true;
        } catch (err) {
          console.warn("[FabricSwatches] Request failed:", err);
          this.rollbackTask(task);
          this.requestCartSync(0);
        }

        /* 清除当前 task 的 pending 状态 */
        this.clearTaskPendingState(task);

        if (!taskSucceeded) {
          /* 失败：rollbackTask 已处理，无需额外操作 */
        } else if (task.type === "add-batch") {
          const confirmedVariantIds = new Set(
            cartData && Array.isArray(cartData.confirmedVariantIds)
              ? cartData.confirmedVariantIds.map((vid) => String(vid))
              : [],
          );
          task.tasks.forEach((addTask) => {
            const vid = String(addTask.variantId);
            if (confirmedVariantIds.has(vid)) {
              this.cartSwatchVariantIds.add(vid);
            } else {
              this.clearLocalSwatchState(vid);
            }
          });
          this.updateAllButtonStates();
          this.updateSelectedCounter();
          this.requestCartSync(
            cartData && cartData.needsCartSync ? 0 : this.cartSyncDelay,
          );
        } else if (cartData) {
          /* remove 返回完整 cart，直接同步 */
          this.syncFromCart(cartData);
          try {
            webvista.publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "fabric-swatches",
              cartData,
            });
          } catch (e) {
            console.warn("[FabricSwatches] publish cartUpdate failed:", e);
          }
        } else {
          this.updateAllButtonStates();
          this.updateSelectedCounter();
        }

        this.processQueue();
      }

      scheduleCartSync(delay = this.cartSyncDelay) {
        if (this.cartSyncTimer) {
          window.clearTimeout(this.cartSyncTimer);
        }
        this.cartSyncTimer = window.setTimeout(async () => {
          this.cartSyncTimer = null;
          try {
            await this.syncCartFromServer();
          } catch (e) {
          }
        }, delay);
      }

      requestCartSync(delay = this.cartSyncDelay) {
        this._needsCartSync = true;
        if (
          typeof this.nextCartSyncDelay !== "number" ||
          delay < this.nextCartSyncDelay
        ) {
          this.nextCartSyncDelay = delay;
        }
      }

      async syncCartFromServer(retries = 2) {
        if (this.cartSyncPromise) return this.cartSyncPromise;

        this.cartSyncInFlight = true;
        this.cartSyncPromise = (async () => {
          let attempt = 0;
          while (attempt <= retries) {
            try {
              const data = await this.requestCartJson(
                window.routes.cart_url + ".js",
                { credentials: "same-origin", cache: "no-store" },
                null,
                "Cart sync failed",
              );
              if (
                window.CartApiProxy &&
                typeof window.CartApiProxy.updateCache === "function"
              ) {
                window.CartApiProxy.updateCache(data);
              }
              this.syncFromCart(data);
              return data;
            } catch (e) {
              if (attempt >= retries) throw e;
              attempt += 1;
              await this.waitForCartRetry(this.cartRetryDelay * attempt);
            }
          }
          return null;
        })();

        try {
          return await this.cartSyncPromise;
        } finally {
          this.cartSyncPromise = null;
          this.cartSyncInFlight = false;
        }
      }

      waitForCartRetry(delay) {
        return new Promise((resolve) => {
          window.setTimeout(resolve, delay);
        });
      }

      waitForQueueIdle() {
        return new Promise((resolve) => {
          const check = () => {
            if (
              !this.addBatchTimer &&
              !this.cartSyncTimer &&
              !this.cartSyncInFlight &&
              this.pendingAddTasks.length === 0 &&
              this.requestQueue.length === 0 &&
              !this.isProcessingQueue
            ) {
              resolve();
              return;
            }
            window.setTimeout(check, 80);
          };
          check();
        });
      }

      getCartRequestStatus(err) {
        return Number(err && (err.status || err.statusCode || err.code));
      }

      async parseCartErrorResponse(res, fallbackMessage) {
        let errorData = {};
        try {
          errorData = await res.clone().json();
        } catch (e) {}
        const message =
          errorData.description ||
          errorData.message ||
          errorData.errors ||
          fallbackMessage;
        const err = new Error(message);
        err.status = res.status;
        return err;
      }

      async requestCartJson(url, fetchConfig, proxyOptions, fallbackMessage, attempt = 0) {
        try {
          if (window.CartApiProxy && proxyOptions) {
            const data = await window.CartApiProxy.fetch(url, fetchConfig, proxyOptions);
            if (Number(data && data.status) === 429) {
              if (attempt === 0) {
                await this.waitForCartRetry(this.cartRetryDelay);
                return this.requestCartJson(
                  url,
                  fetchConfig,
                  proxyOptions,
                  fallbackMessage,
                  attempt + 1,
                );
              }
              const err = new Error(
                data.description || data.message || fallbackMessage,
              );
              err.status = 429;
              throw err;
            }
            return data;
          }

          const res = await fetch(url, fetchConfig);
          if (!res.ok) {
            throw await this.parseCartErrorResponse(res, fallbackMessage);
          }
          return res.json();
        } catch (err) {
          if (this.getCartRequestStatus(err) === 429 && attempt === 0) {
            await this.waitForCartRetry(this.cartRetryDelay);
            return this.requestCartJson(
              url,
              fetchConfig,
              proxyOptions,
              fallbackMessage,
              attempt + 1,
            );
          }
          throw err;
        }
      }

      async executeAddBatch(tasks) {
        const sectionConfigs = this.getCartSectionConfigs();

        const body = {
          items: tasks.map((task) => {
            return {
              id: parseInt(task.variantId, 10),
              quantity: 1,
              properties: task.properties,
            };
          }),
          sections: sectionConfigs.map((s) => s.section),
          sections_url: window.location.pathname,
        };

        const fetchConfig = {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          credentials: "same-origin",
          body: JSON.stringify(body),
        };

        const responseJson = await this.requestCartJson(
          window.routes.cart_add_url + ".js",
          fetchConfig,
          { priority: 'write', source: 'fabric-swatches:add' },
          "Add failed",
        );

        if (responseJson.status) {
          throw new Error(responseJson.description || responseJson.message || "Add failed");
        }

        if (window.CartApiProxy) {
          window.CartApiProxy.markCacheDirty();
        }

        try {
          if (responseJson.sections && typeof SectionDynamicUpdate !== "undefined") {
            SectionDynamicUpdate.updateSections(sectionConfigs, responseJson.sections);
          }
        } catch (e) {
          console.warn("[FabricSwatches] Section update failed:", e);
        }

        /* add 成功后从响应提取 swatch line key 供后续 remove 使用 */
        const confirmedVariantIds = [];

        if (responseJson.items && responseJson.items.length > 0) {
          tasks.forEach((task) => {
            const addedItem = responseJson.items.find(
              (item) =>
                String(item.variant_id) === String(task.variantId) &&
                item.properties &&
                item.properties._is_swatch === "1"
            );
            if (addedItem && addedItem.key) {
              this.cartSwatchLineKeys[task.variantId] = addedItem.key;
              confirmedVariantIds.push(String(task.variantId));
            }
          });
        }

        return {
          confirmedVariantIds,
          needsCartSync: confirmedVariantIds.length !== tasks.length,
        };
      }

      /* remove：cart/change.js 响应即为完整购物车，直接返回 */
      async executeRemove(task) {
        const vid = task.variantId;
        let lineKey = this.cartSwatchLineKeys[vid];

        if (!lineKey) {
          try {
            await this.syncCartFromServer();
          } catch (e) {}
          lineKey = this.cartSwatchLineKeys[vid];
        }

        if (!lineKey) {
          this.clearLocalSwatchState(vid);
          return null;
        }

        const sectionConfigs = this.getCartSectionConfigs();

        const body = {
          id: lineKey,
          quantity: 0,
          sections: sectionConfigs.map((s) => s.section),
          sections_url: window.location.pathname,
        };

        const fetchConfig = {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          credentials: "same-origin",
          body: JSON.stringify(body),
        };

        const responseJson = await this.requestCartJson(
          window.routes.cart_change_url + ".js",
          fetchConfig,
          { priority: 'write', source: 'fabric-swatches:remove' },
          "Remove failed",
        );

        if (responseJson.errors) {
          throw new Error(responseJson.errors);
        }

        if (window.CartApiProxy) {
          window.CartApiProxy.updateCache(responseJson);
        }

        /* 更新 cart drawer / icon DOM */
        try {
          if (responseJson.sections && typeof SectionDynamicUpdate !== "undefined") {
            SectionDynamicUpdate.updateSections(sectionConfigs, responseJson.sections);
          }
        } catch (e) {
          console.warn("[FabricSwatches] Section update failed:", e);
        }

        return responseJson;
      }

      clearTaskPendingState(task) {
        if (task.type === "add-batch") {
          task.tasks.forEach((addTask) => {
            this.pendingAdds.delete(addTask.variantId);
          });
          return;
        }

        this.pendingAdds.delete(task.variantId);
        this.pendingRemoves.delete(task.variantId);
      }

      rollbackTask(task) {
        if (task.type === "add-batch") {
          task.tasks.forEach((addTask) => {
            const vid = String(addTask.variantId);
            this.pendingAdds.delete(vid);
            this.clearLocalSwatchState(vid);
            this.updateButtonState(vid);
          });
        } else if (task.type === "remove") {
          this.pendingRemoves.delete(task.variantId);
        }
        if (task.type !== "add-batch") {
          this.updateButtonState(task.variantId);
        }
        this.updateAllButtonStates();
        this.updateSelectedCounter();

        if (typeof webvista !== "undefined" && webvista.popToast) {
          webvista.popToast("Something went wrong. Please try again.", "error");
        }
      }

      /* 获取需要更新的 cart section 配置 */
      getCartSectionConfigs() {
        const sections = [
          {
            id: "Cart-Icon-Bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section",
          },
        ];

        /* cart-drawer 元素始终存在（不依赖 cart-items），直接读取 data-section */
        const cartDrawer = document.getElementById("Cart-Drawer");
        if (cartDrawer && cartDrawer.dataset.section) {
          sections.push({
            id: "Cart-Drawer",
            section: cartDrawer.dataset.section,
            selector: "#Cart-Drawer-Details",
          });
        }

        return sections;
      }

      prefetchModalImage(url) {
        if (!url || this.prefetchedModalPreviewUrls.has(url)) return;
        this.prefetchedModalPreviewUrls.add(url);

        const img = new Image();
        img.decoding = "async";
        img.src = url;
        if (typeof img.decode === "function") {
          img.decode().catch(() => {});
        }
      }

      findModalForTrigger(trigger) {
        if (!trigger) return null;
        const modalId = trigger.dataset.modalId;
        if (!modalId) return null;

        const collectionBlock = trigger.closest(".fs-collection-block");
        if (collectionBlock) {
          const scopedModal = collectionBlock.querySelector(`#${modalId}`);
          if (scopedModal) return scopedModal;
        }

        return document.getElementById(modalId);
      }

      prefetchModalPreviewForTrigger(trigger) {
        if (!trigger) return;
        const modal = this.findModalForTrigger(trigger);
        if (!modal) return;

        const variantId = trigger.dataset.variantId;
        const target = variantId
          ? modal.querySelector(`.swatch-modal__thumb-btn[data-variant-id="${variantId}"]`)
          : modal.querySelector(".swatch-modal__thumb-btn");
        if (!target) return;

        this.prefetchModalImage(target.dataset.fabricImg);
        this.prefetchModalImage(target.dataset.curtainImg);
      }

      /* ========== 打开 View Details 弹层 ========== */
      initOpenDetail() {
        const warmupFromEventTarget = (eventTarget) => {
          const trigger = eventTarget && eventTarget.closest
            ? eventTarget.closest('[data-action="open-detail"]')
            : null;
          if (!trigger) return;
          this.prefetchModalPreviewForTrigger(trigger);
        };

        this.addEventListener(
          "pointerover",
          (e) => {
            warmupFromEventTarget(e.target);
          },
          { passive: true },
        );

        this.addEventListener(
          "touchstart",
          (e) => {
            warmupFromEventTarget(e.target);
          },
          { passive: true },
        );

        this.addEventListener("focusin", (e) => {
          warmupFromEventTarget(e.target);
        });

        this.addEventListener("click", (e) => {
          if (e.target.closest('[data-action="toggle-card-view"]')) return;

          const trigger = e.target.closest('[data-action="open-detail"]');
          if (!trigger) return;

          /* 阻止冒泡，避免触发 add-swatch 等其他事件 */
          e.stopPropagation();

          const variantId = trigger.dataset.variantId;

          this.prefetchModalPreviewForTrigger(trigger);

          const modal = this.findModalForTrigger(trigger);
          if (!modal) return;

          modal.open(variantId, this);
        });

        /* M 端键盘支持（tabindex="0" 的图片区域） */
        this.addEventListener("keydown", (e) => {
          if (e.key !== "Enter" && e.key !== " ") return;
          const trigger = e.target.closest('[data-action="open-detail"]');
          if (!trigger) return;
          e.preventDefault();
          trigger.click();
        });
      }

      /* ========== 窗口 resize ========== */
      _resizeTimer = null;
      _lastIsMobile = null;
      _mobileToolbarTopRaf = null;

      updateMobileToolbarTop() {
        if (!this.isMobile) {
          document.documentElement.style.setProperty(
            "--fs-toolbar-mobile-top",
            "0px",
          );
          return;
        }

        const headerSection = document.querySelector(".section-header");
        if (!headerSection) {
          document.documentElement.style.setProperty(
            "--fs-toolbar-mobile-top",
            "0px",
          );
          return;
        }

        const headerStatus =
          document.documentElement.getAttribute("data-header-status");
        if (headerStatus === "hidden") {
          document.documentElement.style.setProperty(
            "--fs-toolbar-mobile-top",
            "0px",
          );
          return;
        }

        const headerBottom = Math.max(
          0,
          Math.round(headerSection.getBoundingClientRect().bottom),
        );
        document.documentElement.style.setProperty(
          "--fs-toolbar-mobile-top",
          `${headerBottom}px`,
        );
      }

      scheduleMobileToolbarTopUpdate() {
        if (this._mobileToolbarTopRaf) return;
        this._mobileToolbarTopRaf = window.requestAnimationFrame(() => {
          this._mobileToolbarTopRaf = null;
          this.updateMobileToolbarTop();
        });
      }

      connectedCallback() {
        this._lastIsMobile = this.isMobile;

        this.initCategoryTabs();
        this.initViewToggle();
        this.initFilters();
        this.initCardThumbToggles();
        this.initLoadMore();
        this.initSwatchActions();
        this.initSelectedTray();
        this.initOpenDetail();

        requestAnimationFrame(() => {
          this.applyInitialVisibility();
        });
        // this.applyInitialVisibility();
        this.updateMobileToolbarTop();

        /* 页面加载时锁定所有按钮为 loading 状态 */
        this.setAllButtonsLoading(true);
        this.initCartSync();

        this._handleResize = () => {
          clearTimeout(this._resizeTimer);
          this._resizeTimer = setTimeout(() => {
            if (this.isMobile !== this._lastIsMobile) {
              this._lastIsMobile = this.isMobile;
              this.applyFiltersAndVisibility();
            }
            this.updateMobileToolbarTop();
          }, 200);
        };
        window.addEventListener("resize", this._handleResize);
        this._handleScrollForMobileSticky = () => {
          this.scheduleMobileToolbarTopUpdate();
        };
        window.addEventListener("scroll", this._handleScrollForMobileSticky, {
          passive: true,
        });

        /* 订阅外部购物车变更（如从 cart drawer 删除样品） */
        this._cartUpdateUnsubscribe = webvista.subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          (event) => {
            if (event.source === "fabric-swatches") return;
            if (event.cartData) {
              this.syncFromCart(event.cartData);
            }
          },
        );
      }

      disconnectedCallback() {
        if (this._handleResize) {
          window.removeEventListener("resize", this._handleResize);
        }
        if (this._handleScrollForMobileSticky) {
          window.removeEventListener("scroll", this._handleScrollForMobileSticky);
        }
        if (this.addBatchTimer) {
          window.clearTimeout(this.addBatchTimer);
          this.addBatchTimer = null;
        }
        if (this.cartSyncTimer) {
          window.clearTimeout(this.cartSyncTimer);
          this.cartSyncTimer = null;
        }
        if (this._mobileToolbarTopRaf) {
          window.cancelAnimationFrame(this._mobileToolbarTopRaf);
          this._mobileToolbarTopRaf = null;
        }
        if (this._cartUpdateUnsubscribe) {
          this._cartUpdateUnsubscribe();
        }
      }
    },
  );
}

/* ==========================================================
   第四步：View Details 弹层
   ========================================================== */
if (!customElements.get("swatch-detail-modal")) {
  customElements.define(
    "swatch-detail-modal",
    class SwatchDetailModal extends HTMLElement {
      constructor() {
        super();
        /* 持有对主组件的引用，用于共享购物车状态 */
        this._fabricSwatches = null;
        this._previewSwapToken = 0;
      }

      connectedCallback() {
        this.addEventListener("click", (e) => {
          /* 关闭弹层 */
          if (e.target.closest('[data-action="close-modal"]')) {
            this.close();
            return;
          }
          /* 切换缩略图 */
          const thumbBtn = e.target.closest(".swatch-modal__thumb-btn");
          if (thumbBtn) {
            this._selectItem(thumbBtn);
            return;
          }
        });

        this.addEventListener("keydown", (e) => {
          if (e.key === "Escape") this.close();
        });
      }

      /* 打开弹层，聚焦指定 variantId 对应的颜色 */
      open(variantId, fabricSwatchesEl) {
        this._fabricSwatches = fabricSwatchesEl;

        /* 同步当前视图模式（先执行，确保主图切换逻辑基于当前模式） */
        if (fabricSwatchesEl) {
          this._applyViewMode(fabricSwatchesEl.currentViewMode);
        }

        /* 找到目标 thumb 并激活 */
        const target = variantId
          ? this.querySelector(`.swatch-modal__thumb-btn[data-variant-id="${variantId}"]`)
          : this.querySelector(".swatch-modal__thumb-btn");

        if (target) {
          this._selectItem(target, { smoothScroll: false, skipScroll: true });
        }

        this.removeAttribute("hidden");
        document.body.classList.add("swatch-modal-open");

        /* 焦点移到弹层内 */
        const focusTarget = this.querySelector(".swatch-modal__close");
        if (focusTarget) focusTarget.focus();

        /* 同步按钮状态 */
        this._syncButtons();
      }

      close() {
        this.setAttribute("hidden", "");
        document.body.classList.remove("swatch-modal-open");
        this.classList.remove("swatch-modal--preview-loading");
        this.querySelectorAll(".swatch-modal__img").forEach((img) => {
          img.classList.remove("is-loading");
        });
      }

      _swapPreviewImage(imgEl, nextSrc, altText, showLoading, token) {
        if (!imgEl || !nextSrc) return;

        const currentSrc = imgEl.getAttribute("src");
        if (currentSrc === nextSrc) {
          if (showLoading) {
            imgEl.classList.remove("is-loading");
            this.classList.remove("swatch-modal--preview-loading");
          }
          imgEl.alt = altText || imgEl.alt || "";
          return;
        }

        if (showLoading) {
          this.classList.add("swatch-modal--preview-loading");
          imgEl.classList.add("is-loading");
        }

        const preloadImg = new Image();
        preloadImg.decoding = "async";
        const commit = () => {
          if (token !== this._previewSwapToken) return;
          imgEl.src = nextSrc;
          imgEl.alt = altText || imgEl.alt || "";
          if (showLoading) {
            imgEl.classList.remove("is-loading");
            this.classList.remove("swatch-modal--preview-loading");
          }
        };

        preloadImg.addEventListener("load", commit, { once: true });
        preloadImg.addEventListener("error", commit, { once: true });
        preloadImg.src = nextSrc;

        if (preloadImg.complete) {
          commit();
        }
      }

      /* 切换到指定颜色项 */
      _selectItem(thumbBtn, options = {}) {
        /* 更新缩略图激活态 */
        this.querySelectorAll(".swatch-modal__thumb-btn").forEach((b) =>
          b.classList.remove("is-active")
        );
        thumbBtn.classList.add("is-active");

        /* 滚动缩略图到可视区 */
        if (!options.skipScroll) {
          thumbBtn.scrollIntoView({
            block: "nearest",
            behavior: options.smoothScroll === false ? "auto" : "smooth",
          });
        }

        /* 更新大图 */
        const fabricImg = this.querySelector(".swatch-modal__img--fabric");
        const curtainImg = this.querySelector(".swatch-modal__img--curtain");
        const isCurtainMode = this.classList.contains("swatch-modal--curtain");
        const visibleImg = isCurtainMode ? curtainImg : fabricImg;
        const visibleSrc = isCurtainMode
          ? thumbBtn.dataset.curtainImg
          : thumbBtn.dataset.fabricImg;
        const hiddenImg = isCurtainMode ? fabricImg : curtainImg;
        const hiddenSrc = isCurtainMode
          ? thumbBtn.dataset.fabricImg
          : thumbBtn.dataset.curtainImg;
        const altText = thumbBtn.dataset.productTitle;

        this._previewSwapToken += 1;
        const token = this._previewSwapToken;
        this._swapPreviewImage(visibleImg, visibleSrc, altText, true, token);
        if (hiddenImg && hiddenSrc) {
          hiddenImg.src = hiddenSrc;
          hiddenImg.alt = altText || hiddenImg.alt || "";
        }

        /* 更新右侧标题 */
        const titleEl = this.querySelector("[data-modal-product-title]");
        if (titleEl) titleEl.textContent = thumbBtn.dataset.productTitle;

        /* 更新右侧描述 */
        const descEl = this.querySelector("[data-modal-description]");
        if (descEl) descEl.innerHTML = thumbBtn.dataset.description;

        /* 更新 Add/Remove 按钮属性 */
        const btn = this.querySelector(".swatch-modal__add-btn");
        if (btn) {
          btn.dataset.variantId = thumbBtn.dataset.variantId;
          btn.dataset.productId = thumbBtn.dataset.productId;
          btn.dataset.collectionHandle = thumbBtn.dataset.collectionHandle;
          btn.dataset.collectionTitle = thumbBtn.dataset.collectionTitle;
          btn.dataset.productTitle = thumbBtn.dataset.productTitle;

          if (thumbBtn.dataset.soldOut === "true") {
            btn.classList.add("is-sold-out");
            btn.disabled = true;
            btn.textContent = "Sold Out";
          } else {
            btn.classList.remove("is-sold-out");
            this._syncButtons();
          }
        }

        /* 同步缩略图按钮图片（反映当前视图模式） */
        this._updateThumbImgs();
      }

      /* 同步弹层内 Add/Remove 按钮状态（依赖主组件） */
      _syncButtons() {
        const fs = this._fabricSwatches;
        if (!fs) return;

        const btn = this.querySelector(".swatch-modal__add-btn");
        if (!btn || btn.classList.contains("is-sold-out")) return;

        const vid = String(btn.dataset.variantId);
        const inCart = fs.isVariantInCart(vid);
        const isPending = fs.pendingAdds.has(vid) || fs.pendingRemoves.has(vid);
        const atLimit = fs.isAtLimit();

        btn.classList.toggle("is-added", inCart);
        btn.classList.toggle("is-loading", isPending);
        btn.classList.toggle("is-disabled", !inCart && atLimit);
        btn.textContent = inCart ? "Remove" : "Add Swatch";
        btn.disabled = isPending || (!inCart && atLimit);
      }

      /* 根据视图模式切换大图和缩略图显示 */
      _applyViewMode(mode) {
        this.classList.toggle("swatch-modal--curtain", mode === "curtain");
        this._updateThumbImgs();
      }

      /* 更新缩略图列按钮的图片（反映当前 fabric/curtain 模式） */
      _updateThumbImgs() {
        const fs = this._fabricSwatches;
        const mode = fs ? fs.currentViewMode : "fabric";
        this.querySelectorAll(".swatch-modal__thumb-btn img").forEach((img) => {
          const btn = img.closest(".swatch-modal__thumb-btn");
          img.src = mode === "curtain"
            ? btn.dataset.curtainThumb
            : btn.dataset.fabricThumb;
        });
      }
    },
  );
}
